/**
 * Portrait + background changer locale pack: fr
 */

module.exports = {
  "portrait": {
    "overview": [
      "Miral AI Background Remover est gratuit après connexion et convient bien aux portraits buste : photos LinkedIn, CV, avatars WeChat ou Instagram, et masters transparents pour photos d’identité.",
      "Importez un JPG, PNG ou WebP net jusqu’à 15 Mo. L’IA détecte la personne automatiquement. Avant de télécharger, zoomez sur les cheveux fins, lunettes, boucles d’oreilles et la ligne de col.",
      "Un PNG transparent n’est pas une photo d’identité blanche ou bleue terminée. Gardez d’abord le master transparent, puis ajoutez la couleur requise et recadrez au format officiel."
    ],
    "practice": [
      "Je commence par l’original appareil photo dès que possible. Les miniatures de messagerie et les filtres beauté forts adoucissent les cheveux et rendent les montures plus difficiles à garder intactes.",
      "Je place toujours le détourage sur un fond clair et un fond sombre. Ce seul contrôle révèle les auréoles pâles et les mèches manquantes invisibles en petite prévisualisation."
    ],
    "compareIntro": "Utilisez ce guide pour les personnes — avatars, photos d’identité et portraits pro. Utilisez le guide e-commerce pour les fonds blancs produits, et le guide de changement d’arrière-plan pour une scène café ou bureau après le détourage.",
    "workflow": "Importez un portrait net jusqu’à 15 Mo, laissez l’IA retirer tout l’arrière-plan, inspectez cheveux et lunettes, puis téléchargez un PNG transparent avant d’ajouter blanc, bleu ou couleur de marque.",
    "scenarioIntro": "Choisissez le travail portrait le plus proche du vôtre, puis inspectez les bords qui échouent souvent pour ce cas.",
    "sec": {
      "tldrTitle": "Version courte",
      "tldrCols": [
        "Ce qu’il faut",
        "Détails"
      ],
      "tldrRows": [
        [
          "Prix",
          "Miral AI Background Remover est gratuit après connexion"
        ],
        [
          "Import",
          "JPG, PNG ou WebP jusqu’à 15 Mo"
        ],
        [
          "Idéal pour",
          "Portraits LinkedIn, CV, avatars, masters photo d’identité"
        ],
        [
          "Téléchargement",
          "PNG transparent ; ajoutez blanc ou bleu ensuite"
        ],
        [
          "Vérifier de près",
          "Cheveux, lunettes, boucles d’oreilles, col et épaules"
        ],
        [
          "Pas cet article",
          "Les fonds blancs produits marketplace sont dans le guide e-commerce"
        ]
      ],
      "tldrP": "Un selfie de rue ou un cliché de bureau précipité peut devenir un portrait propre dans Miral AI. Détourez une fois, gardez le fichier transparent, puis construisez la version blanche, bleue ou couleur de marque dont vous avez vraiment besoin.",
      "whatTitle": "Ce dont ont besoin avatars, photos d’identité et portraits LinkedIn",
      "whatP1": "Les trois usages partagent une première étape : détourez la personne avec Miral AI Background Remover et gardez un PNG transparent propre. La différence est la couleur et le recadrage ajoutés ensuite.",
      "whatAvatarP": "Ce que résout le détourage d’avatar : les selfies de chambre et clichés de rue noient le visage dans le désordre. Retirez l’arrière-plan, placez le détourage sur une couleur de marque ou un aplat, puis prévisualisez le crop circulaire pour Instagram, WeChat ou un site perso.",
      "galleryAvatarCaption": "Exemple avatar : à gauche un selfie intérieur encombré ; à droite le détourage sur un aplat prêt pour un crop rond.",
      "whatIdP": "Ce que résout le détourage photo d’identité : les dossiers exigent souvent blanc ou bleu. Un cliché de salon échoue en général. Détourez une fois, ajoutez la couleur requise, puis recadrez au format officiel. Revérifiez toujours les règles actuelles avant envoi.",
      "galleryIdCaption": "Exemple photo d’identité : à gauche un fond domestique chargé ; à droite la même personne sur blanc pur pour le recadrage.",
      "whatLinkedInP": "Ce que résout le détourage LinkedIn : les open spaces mettent écrans et collègues derrière vous. Un fond gris ou blanc calme ramène l’attention sur le visage et les vêtements — ce qu’un recruteur remarque en premier.",
      "galleryLinkedInCaption": "Exemple LinkedIn : à gauche un selfie de bureau chargé ; à droite le détourage sur gris doux prêt pour un profil recruteur.",
      "whatTipTitle": "Un master transparent pour les trois",
      "whatTipText": "Téléchargez d’abord le PNG transparent. Dérivez l’avatar couleur de marque, l’export identité blanc/bleu et la carte LinkedIn gris doux à partir du même fichier.",
      "howTitle": "Quatre étapes vers un portrait utilisable",
      "howP": "Ouvrez Miral AI Background Remover, importez une photo buste, attendez la détection auto, puis zoomez à 100 % sur cheveux et lunettes avant de télécharger. N’ajoutez blanc ou bleu qu’une fois le bord propre.",
      "howTipTitle": "Préférez le fichier original",
      "howTipText": "Les filtres beauté forts et la compression des messageries flouent les mèches. L’original appareil photo gagne presque toujours.",
      "edgeTitle": "Où les portraits échouent souvent",
      "edgeCols": [
        "Zone",
        "Erreur fréquente",
        "Comment vérifier"
      ],
      "edgeRows": [
        [
          "Cheveux fins",
          "Mèches effacées comme fond",
          "Voir sur fonds sombre et clair"
        ],
        [
          "Lunettes",
          "Branche manquante ou trou dans le verre",
          "Zoomer sur les coins de monture"
        ],
        [
          "Boucles / chaînes fines",
          "Lignes métalliques cassées",
          "Suivre le bord du bijou"
        ],
        [
          "Col et ligne de blazer",
          "Auréole blanche ou épaule irrégulière",
          "Placer sur fond sombre"
        ],
        [
          "Barbe ou favoris",
          "Duvet lissé",
          "Réessayer avec moins de retouche sur la source"
        ]
      ],
      "edgeP": "« Ça a l’air bien » en miniature ne suffit pas. La revue pleine taille sur deux couleurs de fond est le test d’honnêteté le plus rapide.",
      "useTitle": "Avatar, LinkedIn, CV et photos type identité",
      "useCols": [
        "Usage",
        "Fond typique",
        "Note pratique"
      ],
      "useRows": [
        [
          "LinkedIn / sites emploi",
          "Gris doux, blanc ou flou propre",
          "Garder le visage net ; les fonds calmes gagnent"
        ],
        [
          "Avatar WeChat / Instagram",
          "Couleur de marque ou dégradé simple",
          "Prévisualiser le crop circulaire avant publication"
        ],
        [
          "Pièce jointe CV",
          "Blanc ou gris clair",
          "Laisser de l’espace au-dessus de la tête et sous les épaules"
        ],
        [
          "Tirages type identité courants",
          "Blanc ou bleu",
          "Ajouter la couleur requise sur le PNG transparent, puis recadrer"
        ],
        [
          "Passeport / visa",
          "Suivre les règles officielles actuelles",
          "Couleur, expression et lunettes varient selon le pays"
        ],
        [
          "Couvertures cours ou live",
          "Couleur de marque ou scène plus tard",
          "Détourez proprement d’abord, puis design de couverture"
        ]
      ],
      "useTipTitle": "Les règles changent",
      "useTipText": "Les règles visa et photo d’examen diffèrent selon le pays et l’année. L’outil nettoie le sujet ; la conformité vient de la checklist officielle.",
      "hairTitle": "Détourage des cheveux et lunettes",
      "hairItems": [
        "Les mèches en contre-jour demandent une source plus simple et contrastée.",
        "Avec des lunettes, confirmez que les deux branches et la zone des verres restent intactes.",
        "Cheveux sombres sur mur sombre : mauvais point de départ — rapprochez-vous d’un mur plus clair si possible.",
        "Pull clair sur mur blanc perd souvent l’épaule ; changez le fond de prise de vue.",
        "Boucles longues et mèches d’enfants : zoom 100 % obligatoire avant téléchargement."
      ],
      "hairP": "Les grandes formes de vêtements ruinent rarement un détourage portrait. Cheveux et lunettes, oui. C’est là que je passe la minute en plus.",
      "troubleTitle": "Quand le portrait semble faux",
      "troubleCols": [
        "Problème",
        "Cause probable",
        "Essayez ceci"
      ],
      "troubleRows": [
        [
          "Morceaux de cheveux manquants",
          "Source douce, compressée ou en contre-jour",
          "Utiliser un original plus net avec moins de beauté"
        ],
        [
          "Liseré pâle sur visage ou épaules",
          "Ancienne couleur de fond collée au bord",
          "Confirmer sur fond sombre, puis réessayer avec plus de contraste"
        ],
        [
          "Monture cassée",
          "Reflets forts qui perturbent le contour",
          "Rephotographier avec une lumière plus douce sur les verres"
        ],
        [
          "Vêtements fondus dans le mur",
          "Faible contraste sujet/fond",
          "Changer le fond plutôt que renvoyer le même fichier"
        ],
        [
          "Photo d’identité jaunâtre",
          "Balance des blancs chaude",
          "Détourez d’abord, puis neutralisez la couleur sur le canvas final"
        ]
      ],
      "troubleTipTitle": "Changez l’entrée",
      "troubleTipText": "Renvoyer le même selfie soft corrige rarement les cheveux. Une source plus propre le fait souvent.",
      "prosConsTitle": "Où ça aide — et où vous décidez encore",
      "bestTitle": "Habitudes qui rendent les avatars utilisables",
      "bestItems": [
        "Cadrage buste avec un peu d’espace au-dessus des cheveux.",
        "Expression naturelle ; évitez le lissage peau fort avant détourage.",
        "Vérifiez le PNG sur fonds clair et sombre à chaque fois.",
        "Stockez master transparent, export identité coloré et crop final en fichiers séparés.",
        "Sur les plateformes emploi, un fond calme fait mieux lire visage et vêtements.",
        "Si vous voulez ensuite une ambiance café ou bureau, détourez proprement d’abord, puis suivez le guide de changement d’arrière-plan."
      ],
      "miralTitle": "Que faire après le détourage",
      "miralP": "Dans Miral AI vous pouvez renforcer le portrait, construire une carte avatar calme, ou continuer dans Seedream ou FLUX.2 pour une scène de couverture. Pour un remplacement lifestyle, ouvrez le guide de changement d’arrière-plan IA. Pour les blancs produits, utilisez le guide e-commerce.",
      "miralLinksTitle": "Prochaines étapes utiles",
      "miralLinks": [
        {
          "label": "Miral AI Background Remover",
          "path": "/tools/background-remover"
        },
        {
          "label": "Guide de changement d’arrière-plan IA",
          "path": "/hub/articles/ai-background-changer-online"
        },
        {
          "label": "Guide général de suppression d’arrière-plan IA",
          "path": "/hub/articles/ai-background-remover-online"
        },
        {
          "label": "Guide fond produit e-commerce",
          "path": "/hub/articles/ecommerce-product-background-removal"
        },
        {
          "label": "AI Image Enhancer",
          "path": "/tools/image-enhancer"
        },
        {
          "label": "Seedream 5",
          "path": "/image-models/seedream-ai-image-generator"
        },
        {
          "label": "FLUX.2",
          "path": "/image-models/flux-2-ai-image-generator"
        }
      ],
      "intentsTitle": "Workflows portrait courants",
      "faqTitle": "Questions avant l’import",
      "faqItems": [
        [
          "Comment retirer un arrière-plan portrait en ligne gratuitement ?",
          "Connectez-vous à Miral AI, importez un JPG, PNG ou WebP buste, puis téléchargez le PNG transparent."
        ],
        [
          "Comment faire une photo d’identité blanche ou bleue à partir d’un selfie ?",
          "Exportez d’abord un PNG transparent, ajoutez le blanc ou bleu requis, recadrez au format officiel et revérifiez les règles actuelles avant envoi."
        ],
        [
          "Comment faire un portrait LinkedIn avec suppression d’arrière-plan ?",
          "Retirez le fond de bureau chargé, placez le détourage sur gris doux ou blanc, et confirmez cheveux et épaules avant upload."
        ],
        [
          "Puis-je retirer gratuitement l’arrière-plan d’un avatar WeChat ou Instagram ?",
          "Oui. Connectez-vous, traitez l’original de l’avatar, puis prévisualisez un crop circulaire sur votre couleur de marque."
        ],
        [
          "Est-il possible de détourer une photo avec lunettes en ligne ?",
          "Oui, mais zoomez sur la monture, les branches et la zone des verres avant de télécharger."
        ],
        [
          "Quel outil utiliser pour le détourage de cheveux sur portraits ?",
          "Utilisez Miral AI Background Remover avec l’original appareil photo, puis vérifiez les mèches sur fonds clair et sombre."
        ],
        [
          "Quel outil pour préparer l’arrière-plan d’une photo passeport ?",
          "Faites d’abord un master portrait transparent, puis exportez la couleur et la taille en millimètres officielles."
        ],
        [
          "Comment corriger une auréole blanche après suppression d’arrière-plan portrait ?",
          "Placez le PNG transparent sur un fond sombre pour localiser le liseré, puis réessayez avec un original plus net et contrasté."
        ],
        [
          "Comment corriger des mèches manquantes sur cheveux bouclés ou enfants ?",
          "Évitez beauté forte et miniatures de chat. Utilisez un original plus clair et revoyez à 100 % avant téléchargement."
        ],
        [
          "Puis-je traiter beaucoup de portraits pro en lot ?",
          "La page actuelle traite une image à la fois pour pouvoir vérifier chaque bord de cheveux."
        ],
        [
          "Quelle différence entre fond identité transparent et blanc ?",
          "Un PNG transparent peut recevoir n’importe quelle couleur ensuite. Un export identité blanc contient déjà des pixels blancs pour formulaires et CV."
        ],
        [
          "Comment changer ensuite l’arrière-plan vers une scène café ou bureau ?",
          "Après validation du PNG transparent, suivez le guide de changement d’arrière-plan IA et vérifiez l’accord de lumière."
        ]
      ]
    },
    "linksTitle": "Continuer dans Miral AI",
    "linksIntro": "Gardez le master portrait transparent, puis améliorez-le, construisez une carte avatar, ou passez à une scène lifestyle.",
    "links": [
      {
        "label": "Miral AI Background Remover",
        "path": "/tools/background-remover"
      },
      {
        "label": "Guide de changement d’arrière-plan IA",
        "path": "/hub/articles/ai-background-changer-online"
      },
      {
        "label": "Guide général de suppression d’arrière-plan IA",
        "path": "/hub/articles/ai-background-remover-online"
      },
      {
        "label": "Guide fond produit e-commerce",
        "path": "/hub/articles/ecommerce-product-background-removal"
      },
      {
        "label": "AI Image Enhancer",
        "path": "/tools/image-enhancer"
      },
      {
        "label": "Seedream 5",
        "path": "/image-models/seedream-ai-image-generator"
      },
      {
        "label": "FLUX.2",
        "path": "/image-models/flux-2-ai-image-generator"
      }
    ],
    "steps": [
      {
        "title": "Choisir une photo buste nette",
        "text": "Utilisez un JPG, PNG ou WebP jusqu’à 15 Mo avec visage et épaules entièrement visibles."
      },
      {
        "title": "Retirer l’arrière-plan automatiquement",
        "text": "Miral AI Background Remover détecte la personne et efface tout le fond — sans contour manuel."
      },
      {
        "title": "Inspecter cheveux et lunettes",
        "text": "Zoomez sur mèches, montures, boucles d’oreilles et ligne de col."
      },
      {
        "title": "Télécharger le PNG transparent, puis ajouter la couleur",
        "text": "Gardez le master, puis ajoutez blanc, bleu, gris ou couleur de marque pour l’usage final."
      }
    ],
    "pros": [
      "Conçu pour les bords portrait des avatars et photos type identité",
      "Pas de plume Photoshop pour les cheveux",
      "Un PNG transparent peut devenir de nombreuses couleurs de fond",
      "Traitement gratuit dans le navigateur après connexion"
    ],
    "cons": [
      "Les cheveux fins demandent encore une revue pleine taille",
      "Contre-jour ou faible contraste peut adoucir les bords",
      "Une image à la fois sur la page actuelle",
      "Les règles officielles d’identité exigent encore une vérification manuelle"
    ],
    "tips": [
      {
        "title": "Vérifier deux couleurs de canvas",
        "text": "Fonds clair et sombre révèlent vite auréoles et mèches manquantes."
      },
      {
        "title": "Protéger lunettes et bijoux",
        "text": "Zoomez sur branches, coins de verres et chaînes fines avant téléchargement."
      },
      {
        "title": "Séparer master et export identité",
        "text": "N’écrasez pas le PNG transparent avec un fichier blanc ou bleu aplati."
      },
      {
        "title": "Garder les filtres légers",
        "text": "La beauté forte adoucit les bords exacts dont le modèle a besoin."
      },
      {
        "title": "Savoir quel guide ouvrir ensuite",
        "text": "Remplacement de scène → changeur d’arrière-plan. Blancs produits → guide e-commerce."
      }
    ],
    "scenarios": [
      {
        "title": "Suppression d’arrière-plan portrait LinkedIn",
        "text": "Détourez un buste net, puis placez-le sur gris doux ou blanc avant upload."
      },
      {
        "title": "Détourage avatar WeChat ou Instagram",
        "text": "Téléchargez un PNG transparent et prévisualisez le crop circulaire sur votre couleur de marque."
      },
      {
        "title": "Photo CV fond blanc",
        "text": "Gardez le master transparent, puis exportez un fichier fond blanc séparé pour le PDF."
      },
      {
        "title": "Photo type identité fond bleu",
        "text": "N’ajoutez le bleu requis qu’une fois le bord des cheveux propre."
      },
      {
        "title": "Retirer le fond autour des cheveux en ligne",
        "text": "Utilisez l’original appareil photo et vérifiez les mèches sur fonds clair et sombre."
      },
      {
        "title": "Détourage portrait avec lunettes",
        "text": "Zoomez sur coins de monture et branches avant de faire confiance au téléchargement."
      },
      {
        "title": "Préparation photo passeport",
        "text": "Faites d’abord le PNG transparent, puis suivez taille et couleur actuelles du pays."
      },
      {
        "title": "Selfie de bureau vers portrait pro",
        "text": "Retirez le désordre du couloir, gardez une expression naturelle, évitez les filtres forts."
      },
      {
        "title": "Détourage enfants ou cheveux bouclés",
        "text": "Attendez-vous à plus de mèches ; revoyez toujours à 100 %."
      },
      {
        "title": "Fond portrait transparent vs blanc",
        "text": "Le transparent reste réutilisable ; le blanc est un export aplati pour un formulaire précis."
      },
      {
        "title": "Corriger une auréole blanche sur un détourage visage",
        "text": "Confirmez le liseré sur fond sombre, puis réessayez avec plus de contraste à la source."
      },
      {
        "title": "Du détourage portrait à une scène café",
        "text": "Utilisez le guide de changement d’arrière-plan après validation du PNG transparent."
      }
    ],
    "toolFaq": [
      {
        "q": "Comment retirer un arrière-plan portrait en ligne gratuitement ?",
        "a": "Connectez-vous, importez un portrait et téléchargez le PNG transparent sans logiciel de bureau."
      },
      {
        "q": "Comment faire une photo d’identité blanche ou bleue à partir d’un selfie ?",
        "a": "Retirez le fond, gardez le PNG transparent, ajoutez la couleur requise, puis recadrez au format officiel."
      },
      {
        "q": "Puis-je retirer gratuitement l’arrière-plan d’un avatar WeChat ou Instagram ?",
        "a": "Oui. Traitez l’original après connexion, puis prévisualisez le crop circulaire sur votre couleur de marque."
      },
      {
        "q": "Est-il possible de détourer une photo avec lunettes en ligne ?",
        "a": "Oui, mais vérifiez branches et zones de verre en pleine taille avant téléchargement."
      },
      {
        "q": "Quel outil pour le détourage de cheveux sur portraits ?",
        "a": "Utilisez Miral AI Background Remover avec un original net et inspectez les mèches sur fonds clair et sombre."
      },
      {
        "q": "Quel outil pour préparer l’arrière-plan d’une photo passeport ?",
        "a": "Créez d’abord un master portrait transparent, puis exportez la couleur et la taille exigées par le formulaire."
      },
      {
        "q": "Comment corriger une auréole blanche après suppression d’arrière-plan portrait ?",
        "a": "Confirmez le liseré sur fond sombre, puis réessayez avec une source plus nette et contrastée."
      },
      {
        "q": "Comment corriger des mèches manquantes sur cheveux bouclés ou enfants ?",
        "a": "Évitez beauté forte et miniatures de chat ; utilisez un original plus clair et revoyez à 100 %."
      },
      {
        "q": "Puis-je traiter beaucoup de portraits pro en lot ?",
        "a": "La page actuelle traite une image à la fois."
      },
      {
        "q": "Comment changer ensuite l’arrière-plan vers une scène café ?",
        "a": "Utilisez le PNG transparent validé avec le workflow de changement d’arrière-plan IA."
      }
    ]
  },
  "changer": {
    "overview": [
      "Le changement d’arrière-plan fonctionne mieux en deux étapes : suppression gratuite vers un PNG transparent propre, puis placement dans une nouvelle scène — lumière de café, bureau calme, mur de marque ou jour extérieur.",
      "Miral AI Background Remover gère le détourage. Seedream ou FLUX.2 peuvent ensuite construire des scènes lifestyle. Ne confondez pas avec les plaques produit blanc pur style Amazon ; ce flux est dans le guide e-commerce.",
      "Si le détourage a encore un liseré pâle, chaque nouvelle scène paraîtra fausse. Corrigez d’abord les bords, puis l’atmosphère."
    ],
    "practice": [
      "Je refuse de composer tant que le sujet transparent n’est pas propre sur un canvas clair et un canvas sombre.",
      "Je fais correspondre la direction de la lumière avant le « joli ». Un portrait en lumière de fenêtre sur une rue néon nocturne trompe rarement."
    ],
    "compareIntro": "Utilisez la suppression d’arrière-plan pour le master transparent, ce guide pour scènes lifestyle ou couvertures, le guide portrait pour couleurs type identité, et le guide e-commerce pour fonds blancs marketplace.",
    "workflow": "Détourez le sujet, choisissez une scène alignée à l’éclairage, composez ou générez le nouvel environnement, puis vérifiez ombres de contact, température de couleur et bords avant export.",
    "scenarioIntro": "Choisissez d’abord l’objectif de scène, puis gardez le master transparent séparé de chaque crop final.",
    "sec": {
      "tldrTitle": "L’ordre qui marche vraiment",
      "tldrCols": [
        "Étape",
        "Garder",
        "Attention"
      ],
      "tldrRows": [
        [
          "1. Retirer le fond",
          "Master PNG transparent Miral AI",
          "Les anciennes auréoles ruinuent chaque scène suivante"
        ],
        [
          "2. Choisir une scène",
          "Café, bureau, mur de marque, extérieur",
          "Choisissez pour le job, pas une esthétique au hasard"
        ],
        [
          "3. Composer ou générer",
          "Image lifestyle ou couverture",
          "Accorder direction de lumière et température"
        ],
        [
          "4. Relire",
          "Export prêt à publier",
          "Bords, échelle et contact au sol"
        ],
        [
          "Séparer des plaques blanches",
          "Guide e-commerce pour SKU blancs",
          "Cet article est pour le remplacement de scène"
        ]
      ],
      "tldrP": "Changer un arrière-plan n’est pas un filtre magique unique. Dans Miral AI vous isolez le sujet avec Background Remover, puis vous lui donnez un nouveau lieu. Sautez le premier travail et le second paraît presque toujours collé.",
      "removeTitle": "Images lifestyle, couvertures sociales et affiches d’événement demandent chacune une plaque différente",
      "removeP1": "Les anciennes couleurs de mur s’accrochent aux cheveux et aux bords de veste. Le chemin stable reste le même : Miral AI Background Remover → master PNG transparent → nouvelle scène pour le job. Les plaques produit blanches marketplace sont dans le guide e-commerce, pas ici.",
      "removeLifestyleP": "Ce que résout le changement lifestyle : lumière de café, places près de la fenêtre et coins de maison créent une ambiance — mais un fond original encombré rend tout le cadre bon marché. Détourez proprement, puis placez la personne dans une scène dont la lumière s’accorde au visage.",
      "galleryLifestyleCaption": "Exemple lifestyle : à gauche le master transparent ; à droite la même personne composée dans une scène de café lumineuse.",
      "removeSocialP": "Ce que résout le changement de couverture sociale : Instagram, Xiaohongshu et en-têtes LinkedIn ont besoin d’un visage clair et d’espace pour un titre. Une chambre encombrée ou un open space remplit le cadre. Un dégradé de marque ou un mur de couleur calme place la personne d’un côté et laisse l’autre pour le texte.",
      "gallerySocialCaption": "Exemple couverture sociale : à gauche le master transparent ; à droite un mur en dégradé de marque avec espace pour un titre.",
      "removePosterP": "Ce que résout le changement d’affiche d’événement : webinaires, lancements de cours et annonces de talk ont besoin d’une scène ou d’un mur de marque calme — pas d’un selfie de bureau. Après le détourage, placez la personne sur une plaque soft de marque avec espace pour le titre, puis ajoutez le texte dans GPT Image si besoin.",
      "galleryPosterCaption": "Exemple affiche d’événement : à gauche le master transparent ; à droite un mur de marque doux adapté à une couverture de talk ou de cours.",
      "removeTipTitle": "Séparer master, scène et crops de couverture",
      "removeTipText": "N’écrasez pas le PNG transparent avec un seul export café ou dégradé. L’affiche de la saison suivante doit réutiliser le même détourage.",
      "howTitle": "Un workflow en ligne pratique",
      "howP": "Ouvrez Miral AI Background Remover et obtenez d’abord un sujet transparent fiable. Puis choisissez un type de fond : aplat le plus rapide, plaque photo réelle ensuite, environnement généré par IA le plus flexible. Avant l’export, vérifiez si la personne semble encore éclairée par le même monde que le fond.",
      "howTipTitle": "La lumière bat la décoration",
      "howTipText": "Un fond plus calme avec une lumière accordée bat une scène dramatique qui combat le visage.",
      "sceneTitle": "Idées de scènes qui tendent à cliquer",
      "sceneCols": [
        "Direction",
        "Bon pour",
        "Attention"
      ],
      "sceneRows": [
        [
          "Café lumineux / place fenêtre",
          "Marque perso et couvertures lifestyle",
          "Ampoules chaudes peuvent pousser la peau trop orange"
        ],
        [
          "Bureau calme / flou étagère soft",
          "LinkedIn et images mentor de cours",
          "Les accessoires de fond doivent rester plus discrets que le visage"
        ],
        [
          "Jour extérieur et verdure",
          "Voyage, bien-être, posts lifestyle",
          "Éviter un zenith dur de midi qui combat l’original"
        ],
        [
          "Mur de marque uni ou dégradé soft",
          "Affiches d’événement et en-têtes sociaux",
          "Garder assez de contraste pour le texte overlay"
        ],
        [
          "Éclairage scène ou keynote",
          "Annonces de talk",
          "Les flares ne doivent pas couper le visage"
        ],
        [
          "Coin lifestyle maison",
          "Storytelling produit doux",
          "Garder perspective et échelle de personne cohérentes"
        ]
      ],
      "sceneP": "Ce qui clique signifie souvent clair, pas encombré. Une personne nette sur un fond calme et intentionnel bat souvent un collage chargé.",
      "qualityTitle": "Cinq endroits où le faux se voit",
      "qualityItems": [
        "Cheveux et épaules : franges blanches ou colorées de l’ancienne pièce.",
        "Direction de lumière : highlight du visage et lumière de fenêtre doivent s’accorder.",
        "Température de couleur : peau d’intérieur chaude sur plaque bleu froid paraît fendue.",
        "Échelle : la personne ne doit pas flotter comme un sticker ni rétrécir dans une mauvaise profondeur.",
        "Contact : un soupçon de sol ou de chaise rend la composition crédible."
      ],
      "qualityTipTitle": "Prévisualiser le crop tôt",
      "qualityTipText": "Vérifiez un crop avatar carré et un crop couverture large avant de valider la scène finale.",
      "vsTitle": "Comment cet article se sépare des autres",
      "vsCols": [
        "Guide",
        "Travail principal",
        "L’ouvrir quand"
      ],
      "vsRows": [
        [
          "Suppression d’arrière-plan IA générale",
          "Tout sujet → PNG transparent",
          "Vous n’avez besoin que du détourage"
        ],
        [
          "Fond produit e-commerce",
          "Plaques produit blanc / transparent",
          "Conformité Amazon, Shopify"
        ],
        [
          "Suppression d’arrière-plan portrait",
          "Avatars et couleurs type identité",
          "Visages, cheveux, masters blanc/bleu"
        ],
        [
          "Changeur d’arrière-plan IA (celui-ci)",
          "Remplacement de scène après détourage",
          "Atmosphère café, bureau, mur de marque"
        ]
      ],
      "vsP": "Croisez les quatre guides, mais gardez les mots-clés honnêtes. Les plaques produit blanches n’appartiennent pas à un article lifestyle, et les photos d’identité bleu visa n’appartiennent pas à un pitch de composition café.",
      "troubleTitle": "Quand la nouvelle scène semble fausse",
      "troubleCols": [
        "Problème",
        "Cause",
        "Correction"
      ],
      "troubleRows": [
        [
          "Frange claire autour du sujet",
          "Détourage encore sale",
          "Revenir à la suppression avec un original plus contrasté"
        ],
        [
          "Effet sticker",
          "Contact manquant ou lumière désaccordée",
          "Adoucir la plaque ou ajouter une ombre de contact très légère"
        ],
        [
          "Peau grise ou orange",
          "Choc de température de couleur",
          "Choisir une scène plus proche ou unifier le grade"
        ],
        [
          "Cheveux sales",
          "Alpha incomplet autour des mèches",
          "Nettoyer le détourage avant de recomposer"
        ],
        [
          "Forme produit dérive dans une scène IA",
          "La génération a changé l’objet",
          "Verrouiller l’identité ; laisser l’IA inventer seulement l’environnement"
        ]
      ],
      "prosConsTitle": "Ce que ce workflow débloque",
      "bestTitle": "Des remplacements qui tiennent sur un écran de téléphone",
      "bestItems": [
        "Ne sautez jamais le master transparent propre.",
        "Laissez le canal décider la scène : recrutement reste calme, lifestyle peut respirer, affiches ont besoin d’espace titre.",
        "Un éclairage source simple facilite le remplacement.",
        "Prévisualisez toujours sur un écran taille téléphone avant publication.",
        "Ajoutez le texte de titre après que la scène fonctionne — GPT Image peut aider pour le type d’affiche.",
        "Envoyez les SKU blancs marketplace au guide e-commerce pour séparer les intentions."
      ],
      "miralTitle": "Garder la chaîne dans Miral AI",
      "miralP": "Chemin suggéré dans Miral AI : Background Remover → Image Enhancer optionnel → Seedream ou FLUX.2 pour l’environnement → GPT Image si vous avez besoin de texte d’affiche. Pour cartes identité blanc ou bleu, revenez au guide portrait.",
      "miralLinksTitle": "Prochaines étapes utiles",
      "miralLinks": [
        {
          "label": "Miral AI Background Remover",
          "path": "/tools/background-remover"
        },
        {
          "label": "Guide portrait et photo d’identité",
          "path": "/hub/articles/ai-portrait-background-remover"
        },
        {
          "label": "Guide général de suppression d’arrière-plan IA",
          "path": "/hub/articles/ai-background-remover-online"
        },
        {
          "label": "Guide fond produit e-commerce",
          "path": "/hub/articles/ecommerce-product-background-removal"
        },
        {
          "label": "AI Image Enhancer",
          "path": "/tools/image-enhancer"
        },
        {
          "label": "Seedream 5",
          "path": "/image-models/seedream-ai-image-generator"
        },
        {
          "label": "FLUX.2",
          "path": "/image-models/flux-2-ai-image-generator"
        },
        {
          "label": "GPT Image 1.5",
          "path": "/image-models/gpt-image-ai-image-generator"
        }
      ],
      "intentsTitle": "Jobs courants de changement d’arrière-plan",
      "faqTitle": "Questions pratiques",
      "faqItems": [
        [
          "Comment changer un arrière-plan photo en ligne gratuitement ?",
          "Connectez-vous à Miral AI, exportez un PNG transparent avec Background Remover, puis placez le sujet sur un café, un mur de marque ou une nouvelle scène."
        ],
        [
          "Comment faire une image lifestyle à partir d’un PNG transparent ?",
          "Composez sur une plaque à lumière accordée, vérifiez contact et température, et séparez master et crops de couverture."
        ],
        [
          "Comment changer un fond de couverture sociale après détourage ?",
          "Après validation des bords de cheveux, placez le sujet d’un côté d’un dégradé de marque et laissez de l’espace pour le titre."
        ],
        [
          "Puis-je remplacer le fond d’un selfie par une scène de café ?",
          "Oui. Détourez proprement d’abord, puis composez dans une plaque café dont la lumière de fenêtre s’accorde au visage."
        ],
        [
          "Est-il possible de générer une nouvelle scène IA derrière une vraie personne ?",
          "Oui. Gardez le vrai sujet du PNG transparent et laissez Seedream ou FLUX.2 inventer seulement l’environnement."
        ],
        [
          "Quel outil pour remplacer le fond d’une affiche d’événement ?",
          "Utilisez Miral AI Background Remover pour le détourage, placez-le sur un mur de marque soft, puis ajoutez le titre dans GPT Image si besoin."
        ],
        [
          "Quel outil pour remplacer le fond d’une couverture sociale ?",
          "Background Remover plus un mur couleur de marque ou dégradé. Continuez dans Seedream ou FLUX.2 pour une scène lifestyle plus complète."
        ],
        [
          "Comment corriger une composition d’arrière-plan qui paraît fausse ?",
          "Inspectez frange, direction de lumière et température dans cet ordre. Si les bords sont sales, revenez d’abord à la suppression."
        ],
        [
          "Comment corriger un désaccord de jour extérieur en changeant d’arrière-plan ?",
          "Accordez la direction du soleil ; évitez un zenith dur de midi sur un visage éclairé pour l’intérieur."
        ],
        [
          "Puis-je utiliser le changement d’arrière-plan pour une couverture vidéo ?",
          "Oui. Exportez le crop au ratio de couverture et gardez le sujet dans la zone sûre."
        ],
        [
          "Quelle différence entre suppression et changement d’arrière-plan ?",
          "La suppression donne un sujet transparent. Le changement place ce sujet dans une nouvelle scène ou couleur."
        ],
        [
          "Puis-je utiliser ceci pour des fonds produits blancs Amazon ?",
          "Non. Les plaques blanches marketplace sont dans le guide e-commerce ; cet article est pour scènes lifestyle et couvertures."
        ]
      ]
    },
    "linksTitle": "Construire le workflow de scène dans Miral AI",
    "linksIntro": "Détourez une fois, gardez le master transparent, puis créez scènes lifestyle, couvertures ou plaques d’affiche sans refaire le masque.",
    "links": [
      {
        "label": "Miral AI Background Remover",
        "path": "/tools/background-remover"
      },
      {
        "label": "Guide portrait et photo d’identité",
        "path": "/hub/articles/ai-portrait-background-remover"
      },
      {
        "label": "Guide général de suppression d’arrière-plan IA",
        "path": "/hub/articles/ai-background-remover-online"
      },
      {
        "label": "Guide fond produit e-commerce",
        "path": "/hub/articles/ecommerce-product-background-removal"
      },
      {
        "label": "AI Image Enhancer",
        "path": "/tools/image-enhancer"
      },
      {
        "label": "Seedream 5",
        "path": "/image-models/seedream-ai-image-generator"
      },
      {
        "label": "FLUX.2",
        "path": "/image-models/flux-2-ai-image-generator"
      },
      {
        "label": "GPT Image 1.5",
        "path": "/image-models/gpt-image-ai-image-generator"
      }
    ],
    "steps": [
      {
        "title": "Détourer d’abord un sujet propre",
        "text": "Utilisez Miral AI Background Remover pour télécharger un PNG transparent et confirmer cheveux ou bords produit."
      },
      {
        "title": "Décider le feeling de la nouvelle scène",
        "text": "Café, bureau calme, jour extérieur ou mur de marque — choisissez pour le canal."
      },
      {
        "title": "Placer le sujet dans le nouvel arrière-plan",
        "text": "Composez sur un canvas design ou continuez dans Seedream / FLUX.2 avec lumière accordée."
      },
      {
        "title": "Vérifier lumière, échelle et contact",
        "text": "Cherchez franges, choc de couleur, mauvaise taille et contact manquant."
      },
      {
        "title": "Exporter le crop dont vous avez besoin",
        "text": "Enregistrez tailles couverture et avatar séparément et laissez le master transparent intact."
      }
    ],
    "pros": [
      "Un master transparent soutient de nombreuses scènes",
      "Moins cher que reshooter chaque environnement",
      "Bon fit pour couvertures sociales et cadres lifestyle",
      "Se connecte proprement au travail de scène Seedream et FLUX.2"
    ],
    "cons": [
      "Une lumière désaccordée se lit comme fausse immédiatement",
      "Des bords de détourage sales gâchent toute la composition",
      "Les SKU blancs marketplace doivent utiliser le guide e-commerce",
      "Les scènes à perspective complexe peuvent encore demander une finition manuelle"
    ],
    "tips": [
      {
        "title": "Bords avant atmosphère",
        "text": "Ne composez jamais un détourage qui montre encore une auréole sur fond sombre."
      },
      {
        "title": "Accorder d’abord la lumière",
        "text": "Choisissez des plaques dont la lumière principale s’accorde au visage ou au produit."
      },
      {
        "title": "Séparer les masters",
        "text": "PNG transparent, export lifestyle et crops sociaux doivent être des fichiers différents."
      },
      {
        "title": "Laisser de la place pour le texte",
        "text": "Les fonds d’affiche ont besoin de zones plus calmes où un titre peut s’asseoir."
      },
      {
        "title": "Séparer les intentions de recherche",
        "text": "Envoyez les plaques blanches Amazon à l’article e-commerce ; gardez celui-ci pour le changement de scène."
      }
    ],
    "scenarios": [
      {
        "title": "Remplacer un arrière-plan photo en ligne gratuitement",
        "text": "Détourez d’abord le sujet, puis placez-le sur une nouvelle plaque ou scène générée."
      },
      {
        "title": "Fond portrait lifestyle café",
        "text": "Utilisez une plaque en lumière de fenêtre qui s’accorde à l’éclairage du visage."
      },
      {
        "title": "Fond de bureau pour une photo pro",
        "text": "Gardez étagères et accessoires plus doux que la personne."
      },
      {
        "title": "Fond couleur de marque pour couverture sociale",
        "text": "PNG transparent sur aplat ou dégradé soft avec espace pour le titre."
      },
      {
        "title": "Changer l’arrière-plan après détourage IA",
        "text": "Ne composez pas tant que cheveux et bords de veste n’ont pas passé un contrôle deux canvas."
      },
      {
        "title": "Scène IA générée derrière une vraie personne",
        "text": "Laissez Seedream ou FLUX.2 inventer la pièce, pas un nouveau visage ou tenue."
      },
      {
        "title": "Remplacement de fond d’affiche d’événement",
        "text": "Préférez des murs de marque propres pour que le titre reste lisible."
      },
      {
        "title": "Échange de fond jour extérieur",
        "text": "Accordez la direction du soleil ; évitez un zenith de midi sur un visage soft d’intérieur."
      },
      {
        "title": "Corriger une composition d’arrière-plan fausse",
        "text": "Inspectez frange, direction de lumière et température dans cet ordre."
      },
      {
        "title": "PNG transparent vers image lifestyle",
        "text": "Archivez le master, exportez les crops de couverture séparément."
      },
      {
        "title": "Pas pour fonds blancs Amazon",
        "text": "Envoyez les plaques listing au guide produit e-commerce."
      },
      {
        "title": "Détourage portrait puis changement de scène",
        "text": "Terminez la revue des cheveux dans le workflow portrait, puis ouvrez ce workflow de scène."
      }
    ],
    "toolFaq": [
      {
        "q": "Comment changer un arrière-plan photo en ligne gratuitement ?",
        "a": "Connectez-vous, retirez le fond original vers un PNG transparent, puis placez le sujet sur une nouvelle scène ou un aplat."
      },
      {
        "q": "Comment faire une image lifestyle à partir d’un PNG transparent ?",
        "a": "Composez sur une plaque à lumière accordée, vérifiez contact et température, et séparez le master des crops de couverture."
      },
      {
        "q": "Puis-je remplacer le fond d’un selfie par une scène de café ?",
        "a": "Oui. Détourez d’abord la personne, puis composez dans une plaque café avec une lumière de fenêtre similaire."
      },
      {
        "q": "Est-il possible de générer une nouvelle scène IA derrière une vraie personne ?",
        "a": "Oui. Gardez le vrai sujet et laissez Seedream ou FLUX.2 créer seulement l’environnement."
      },
      {
        "q": "Quel outil pour remplacer le fond d’une affiche d’événement ?",
        "a": "Utilisez Background Remover pour le détourage, placez-le sur un mur de marque calme, puis ajoutez le titre si besoin."
      },
      {
        "q": "Quel outil pour remplacer le fond d’une couverture sociale ?",
        "a": "Background Remover plus mur couleur de marque ou dégradé ; continuez dans Seedream ou FLUX.2 pour des scènes lifestyle plus riches."
      },
      {
        "q": "Comment corriger une composition d’arrière-plan qui paraît fausse ?",
        "a": "Nettoyez la frange, accordez la direction de lumière et unifiez la température avant export."
      },
      {
        "q": "Comment corriger un désaccord de jour extérieur en changeant d’arrière-plan ?",
        "a": "Accordez la direction du soleil et évitez un zenith de midi sur un visage éclairé pour l’intérieur."
      },
      {
        "q": "Puis-je utiliser le changement d’arrière-plan pour une couverture vidéo ?",
        "a": "Oui. Exportez le crop au ratio de couverture et gardez le sujet dans la zone sûre."
      },
      {
        "q": "Puis-je utiliser ceci pour des fonds produits blancs Amazon ?",
        "a": "Non. Utilisez le guide fond produit e-commerce pour les plaques blanches marketplace."
      }
    ]
  },
  "articles": {
    "ai-portrait-background-remover": {
      "title": "Suppression d’arrière-plan portrait IA gratuite pour portraits, avatars et photos d’identité",
      "excerpt": "Transformez un selfie chargé en portrait propre : retirez l’arrière-plan portrait gratuitement, exportez un PNG transparent, puis ajoutez blanc, bleu ou couleur de marque pour LinkedIn, CV et avatars.",
      "metaTitle": "Suppression d’arrière-plan portrait IA gratuite | Miral",
      "metaDescription": "Retirez gratuitement les arrière-plans portrait avec Miral AI. Gardez le détail des cheveux, exportez des PNG transparents, et créez des portraits LinkedIn ou photos type identité blanc et bleu.",
      "target": {
        "label": "Ouvrir la suppression d’arrière-plan portrait",
        "path": "/tools/background-remover"
      },
      "keywords": [
        "suppression arrière-plan portrait gratuite",
        "détourage portrait IA",
        "fond photo LinkedIn",
        "fond photo d’identité",
        "détourage avatar",
        "retirer fond autour des cheveux",
        "photo CV fond blanc",
        "photo d’identité fond bleu en ligne"
      ]
    },
    "ai-background-changer-online": {
      "title": "Changeur d’arrière-plan IA gratuit : scènes de vie, couvertures sociales et affiches",
      "excerpt": "Retirez l’ancien fond gratuitement, puis placez des personnes dans des scènes café style de vie, des couvertures en dégradé de marque ou des murs d’affiche — sans concurrencer l’intention fond blanc e-commerce.",
      "metaTitle": "Changeur d’arrière-plan IA gratuit en ligne | Miral",
      "metaDescription": "Changez les arrière-plans photo en ligne avec Miral AI : détourez en PNG transparent, puis créez scènes café style de vie, couvertures sociales et affiches d’événement.",
      "target": {
        "label": "Ouvrir la suppression d’arrière-plan IA",
        "path": "/tools/background-remover"
      },
      "keywords": [
        "changeur arrière-plan IA gratuit",
        "remplacer fond photo en ligne",
        "changer fond après détourage",
        "remplacement de scène IA",
        "changeur fond lifestyle",
        "fond café pour portrait",
        "remplacement fond couverture sociale",
        "PNG transparent nouveau fond"
      ]
    }
  }
}
